import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const DataTable = ({ actions, data }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const rowsPerPage = 10;
    const [page, setPage] = useState(1);
        const handleChange = (event, value) => {
        setPage(value);
    };

    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = data?.slice(startIndex, endIndex);



    useEffect(() => {
        const totalPages = Math.ceil(data.length / rowsPerPage);
        if (page > totalPages && totalPages > 0) {
            setPage(totalPages);
        } else if (data.length === 0) {
            setPage(1);
        }
    }, [data, page, rowsPerPage]);



    return (
        <div className="overflow-x-auto">
            {paginatedData?.length > 0 ? (
                <>
                    <table className="min-w-full border-collapse border border-gray-200">
                        <thead>
                            <tr className="bg-sky-600 text-white">
                                <th className="border p-2 text-left">Name</th>
                                <th className="border p-2 text-left">Role</th>
                                <th className="border p-2 text-left">Email</th>
                                <th className="border p-2 text-center w-20">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData?.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    {/* Name Column */}
                                    <td className="border p-2">{item.Name}</td>

                                    {/* Role Column */}
                                    <td className="border p-2">{item.Role}</td>

                                    {/* Email Column */}
                                    <td className="border p-2">{item.Email}</td>

                                    {/* Actions Column */}
                                    {actions?.length > 0 && (
                                        <td className="border p-2  w-fit text-center">
                                            <div className="flex justify-center gap-2">
                                                {actions.map((action, actionIndex) => {
                                                    const ButtonComponent = action.ButtonComponent;
                                                    return (
                                                        <ButtonComponent
                                                            key={actionIndex}
                                                            action={() => action.handler(item, index)}
                                                            tooltip={action.tooltip}
                                                            id={index}
                                                            itemName={item.Name}
                                                            itemData={item}
                                                            label={action.label}
                                                            className={action.className}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </>
            ) : (
                <div className="flex justify-center items-center m-auto p-6 bg-gray-100 text-gray-500 rounded-lg shadow-md">
                    <p className="text-lg font-semibold">No Data Found</p>
                </div>
            )}

            {/* Pagination Controls */}
            <div className="flex justify-center mt-4">
                <Stack spacing={2}>
                    <Pagination
                        count={Math.ceil(data.length / rowsPerPage)}
                        page={page}
                        onChange={handleChange}
                        color="primary"
                    />
                </Stack>
            </div>
        </div>


    );
};

export default DataTable;
